export interface ServiceContainer {
  get<T>(token: string): T;
  register<T>(token: string, factory: () => T): void;
  clear(token: string): void;
  clearAll(): void;
}

export class DefaultServiceContainer implements ServiceContainer {
  private readonly services: Map<string, any> = new Map();
  private readonly factories: Map<string, () => any> = new Map();

  get<T>(token: string): T {
    if (this.services.has(token)) {
      return this.services.get(token) as T;
    }

    const factory = this.factories.get(token);
    if (!factory) {
      throw new Error(`Service '${token}' not registered`);
    }

    const service = factory();
    this.services.set(token, service);
    return service as T;
  }

  register<T>(token: string, factory: () => T): void {
    this.factories.set(token, factory);
    // Clear cached instance if it exists to ensure new factory is used
    this.services.delete(token);
  }

  clear(token: string): void {
    this.services.delete(token);
  }

  clearAll(): void {
    this.services.clear();
  }
}

export const container = new DefaultServiceContainer();